import React from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getBoxSettingTransparency } from 'services/setting'

export default function useGetTransparency() {
    const { id } = useParams()
    const { data, isLoading, refetch } = useQuery(
        ['get-box-transparency', id],
        getBoxSettingTransparency
    )
    return { data, isLoading, refetch }
}
